import type { CompanyAnalysisService } from "./types";

export default function createCompanyAnalysisSettingsService(): CompanyAnalysisService {
    return {
        getComponentsConfigId() {
            return "SalesAccountOverview";
        },
    };
}
